import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Banner.css';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

export const PreviousBtn = ({ className, onClick }) => {
  const theme = useTheme();
  return (
    <Box
      className={className}
      onClick={onClick}
      sx={{
        width: '47px',
        height: '104px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 8px 12px rgba(0,0,0,.2)',
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        zIndex: 1,
        borderRadius: '0 5px 5px 0',
        left: 0,
        '&::before': {
          display: 'none',
        },
      }}
    >
      <ArrowBackIosIcon />
    </Box>
  );
};

export const NextBtn = ({ className, onClick }) => {
  const theme = useTheme();
  return (
    <Box
      className={className}
      onClick={onClick}
      sx={{
        width: '47px',
        height: '104px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 8px 12px rgba(0,0,0,.2)',
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        zIndex: 1,
        borderRadius: '5px 0 0 5px',
        right: 0,
        '&::before': {
          display: 'none',
        },
      }}
    >
      <ArrowForwardIosIcon />
    </Box>
  );
};

const Banner = ({ banners }) => {

  const settings = {
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PreviousBtn />,
    nextArrow: <NextBtn />,
  };

  return (
    <>
      <section className="h-44 sm:h-72 w-full rounded-sm shadow relative overflow-hidden">
        <Slider {...settings}>
          {banners && banners.map((el, i) => (
            <img draggable="false" className="h-44 sm:h-72 w-full object-cover" src={el.url} alt="banner" key={i} />
          ))}
        </Slider>
      </section>
    </>
  );
};

export default Banner;
